var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"risk-score-legend"},[_c('div',{staticClass:"risk-score-legend__letter",style:({'color': _vm.color})},[_vm._v(_vm._s(_vm.letter))]),_c('div',{staticClass:"risk-score-legend__text",style:({'color': _vm.color})},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }